export type StoreBannerTheme = 'light' | 'blue' | 'lightBlue';
export type StoreBannerSource = 'homepage' | 'breed' | 'litter' | 'pro';

export interface StoreBannerData {
  theme?: StoreBannerTheme;
  source?: StoreBannerSource;
  useMobileImage?: boolean;
}

export interface StoreBannerProps extends StoreBannerData {}
